import React from 'react';
import { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import FillProfileImage from '../../Components/ImagesWithElements/FillProfileImage';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import type { RadioChangeEvent } from 'antd';
import { Radio } from 'antd';
import { Button } from 'antd';
import usePortalService from '../../services/PortalService';
import ErrorMessage from '../../Components/Errors/ErrorMessage';

const Styles = styled.div`
    .progress {
    position: absolute;
    width: 67%;
    height: 6px;
    left: 0px;
    top: 0px;
    background: #2196F3
}
`

export const FillProfileStudent2 = () => {
    const navigate = useNavigate();

    const {addEducation, profileCommonInformation, educationInformation, error, clearError} = usePortalService();

    const [firstName, setFirstName] = useState('');

    const [educationLevel, setEducationLevel] = useState('СПО');
    const [educationLevelDirty, setEducationLevelDirty] = useState(false);
    const [educationLevelError, setEducationLevelError] = useState('');

    const [institute, setInstitute] = useState('');
    const [instituteDirty, setInstituteDirty] = useState(false);
    const [instituteError, setInstituteError] = useState('Введите название образовательного учреждения');

    const [specializationName, setSpecializationName] = useState('');
    const [specializationNameDirty, setSpecializationNameDirty] = useState(false);
    const [specializationNameError, setSpecializationNameError] = useState('Введите название специальности');

    const regSpecializationCode = /^\d\d\.\d\d\.\d\d$/;
    const [specializationCode, setSpecializationCode] = useState('');
    const [specializationCodeDirty, setSpecializationCodeDirty] = useState(false);
    const [specializationCodeError, setSpecializationCodeError] = useState('Введите номер специальности');

    const regGraduationYear = /^((19)|(20))\d{2}$/;
    const [graduationYear, setGraduationYear] = useState('');
    const [graduationYearDirty, setGraduationYearDirty] = useState(false);
    const [graduationYearError, setGraduationYearError] = useState('Введите год выпуска');

    const [targetStatus, setTargetStatus] = useState(false);

    const [companyName, setCompanyName] = useState('');
    const [companyNameDirty, setCompanyNameDirty] = useState(false);
    const [companyNameError, setCompanyNameError] = useState('Введите название компании');

    const blurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
        switch (e.target.name) {
            case 'educationLevel':
                setEducationLevelDirty(true)
                break;
            case 'institute':
                setInstituteDirty(true)
                break;
            case 'specializationName':
                setSpecializationNameDirty(true)
                break;
            case 'specializationCode':
                setSpecializationCodeDirty(true)
                break;
            case 'graduationYear':
                setGraduationYearDirty(true)
                break;
            case 'companyName':
                setCompanyNameDirty(true)
                break;
        }
    }

    const educationLevelHandler = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setEducationLevel(e.target.value)
    };

    const instituteHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInstitute(e.target.value)
        if (e.target.value.length == 0) {
            setInstituteError('Название учебного учреждения не может быть пустым')
        } else if (e.target.value.length < 2) {
            setInstituteError('Название учебного учреждения не может состоять из одного символа')
        } else {
            setInstituteError('')
        }
    }

    const specializationNameHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSpecializationName(e.target.value)
        if (e.target.value.length == 0) {
            setSpecializationNameError('Название специальности не может быть пустым')
        } else if (e.target.value.length < 2) {
            setSpecializationNameError('Название специальности не может состоять из одного символа')
        } else {
            setSpecializationNameError('')
        }
    }

    const specializationCodeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSpecializationCode(e.target.value)
        if (!regSpecializationCode.test(String(e.target.value).toLowerCase())) {
            setSpecializationCodeError('Некорректный код специальности')
        } else {
            setSpecializationCodeError('')
        }
    }

    const graduationYearHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setGraduationYear(e.target.value)
        if (!regGraduationYear.test(String(e.target.value).toLowerCase())) {
            setGraduationYearError('Некорректный год выпуска')
        } else {
            setGraduationYearError('')
        }
    }

    const onTargetStatusChange = (e: RadioChangeEvent) => {
        setTargetStatus(e.target.value);
    };
    
    const companyNameHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCompanyName(e.target.value)
        if (e.target.value.length == 0) {
            setCompanyNameError('Название компании не может быть пустым')
        } else if (e.target.value.length < 2) {
            setCompanyNameError('Название компании не может состоять из одного символа')
        } else {
            setCompanyNameError('')
        }
    }

    useEffect(() => {
        profileCommonInformation().then(result => {
            setFirstName(result.profile.firstName);
        });
        educationInformation().then(result => {
            setTargetStatus(result.educationProfile.isTargetEducation);
            let item = result.educationProfile.educationLevel;
            if (item) {
                setEducationLevel(item);
            } else {
                setEducationLevel('СПО');
            }
            item = result.educationProfile.educationalInstitution;
            if (item) {
                setInstitute(item);
                setInstituteError('');
            }
            item = result.educationProfile.specialtyName;
            if (item) {
                setSpecializationName(item);
                setSpecializationNameError('');
            }
            item = result.educationProfile.specialtyNumber;
            if (item) {
                setSpecializationCode(item);
                setSpecializationCodeError('');
            }
            item = result.educationProfile.targetCompany;
            if (item) { 
                setCompanyName(item);
                setCompanyNameError('');
            }
            item = result.educationProfile.yearGraduation;
            if (item) {
                setGraduationYear(item);
                setGraduationYearError('');
            }
        });
    }, []);

    const handleContinue = async (e: React.FormEvent) => {
        e.preventDefault();
        if (educationLevelError || instituteError || specializationNameError|| specializationCodeError || graduationYearError || (targetStatus && companyNameError)) {
            setEducationLevelDirty(true)
            setInstituteDirty(true)
            setSpecializationNameDirty(true)
            setSpecializationCodeDirty(true)
            setGraduationYearDirty(true)
            setCompanyNameDirty(true)
        } else {
            try {
                clearError();
                const result = await addEducation({
                    educationLevel,
                    educationalInstitution : institute,
                    yearGraduation : graduationYear,
                    specialtyNumber : specializationCode,
                    specialtyName : specializationName,
                    isTargetEducation : targetStatus,
                    targetCompany : companyName
                });

                if (result.success) {
                    navigate("/fillProfile3");
                }
            } catch {
                // ошибка уже сохранена в error и отображается ниже
            }
        }
    }

    return (
        <>
            <div className="main-container">
                <section className="auth-sidebar d-none d-md-block">
                    <FillProfileImage firstName={firstName} />
                </section>
                <div className="content" >
                    <div className="auth-content">
                        <p className="step">Шаг 2 из 3</p>
                        <h1 style={{ marginBottom: '32px' }}> Образование </h1>
                        <Form>
                            <div className="form-group">
                                <Form.Label> Уровень образования </Form.Label>
                                <Form.Select /* placeholder='Выберите из списка'  */value={educationLevel} onChange={e => educationLevelHandler(e)}>
                                    <option value='СПО'> СПО </option>
                                    <option value='Бакалавр ВО'> Бакалавр ВО </option>
                                    <option value='Магистр ВО'> Магистр ВО </option>
                                    <option value='Специалист ВО'> Специалист ВО </option>
                                    <option value='Аспирантура (исследователь, кандидат наук) ВО'> Аспирантура (исследователь, кандидат наук) ВО </option>
                                </Form.Select>
                                {(educationLevelDirty && educationLevelError) && <p className="error-alert">{educationLevelError}</p>}
                            </div>
                            <Form.Group className="form-group" controlId="formInstitute">
                                <Form.Label> Образовательное учреждение </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name='institute'
                                    value={institute} 
                                    onBlur={blurHandler} 
                                    onChange={instituteHandler}
                                    isInvalid={!!(instituteDirty && instituteError)} />
                                {(instituteDirty && instituteError) && <p className="error-alert">{instituteError}</p>}
                            </Form.Group>
                            <Form.Group className="form-group" controlId="formSpecializationName">
                                <Form.Label> Название специальности </Form.Label>
                                <Form.Control 
                                    type="text" 
                                    name='specializationName'
                                    value={specializationName} 
                                    onBlur={blurHandler} 
                                    onChange={specializationNameHandler}
                                    isInvalid={!!(specializationNameDirty && specializationNameError)} 
                                />
                                {(specializationNameDirty && specializationNameError) && <p className="error-alert">{specializationNameError}</p>}
                            </Form.Group>
                            <div className="pair-input">
                                <Form.Group className="form-group first-in-pair" controlId="formSpecializationCode">
                                    <Form.Label> Номер специальности </Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name='specializationCode'
                                        value={specializationCode} 
                                        onBlur={blurHandler} 
                                        onChange={specializationCodeHandler}
                                        isInvalid={!!(specializationCodeDirty && specializationCodeError)} 
                                    />
                                    {(specializationCodeDirty && specializationCodeError) && <p className="error-alert">{specializationCodeError}</p>}
                                </Form.Group>
                                <Form.Group className="form-group second-in-pair" controlId="formLastName">
                                    <Form.Label> Год окончания  </Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name='graduationYear'
                                        value={graduationYear} 
                                        onBlur={blurHandler} 
                                        onChange={graduationYearHandler}
                                        isInvalid={!!(graduationYearDirty && graduationYearError)} 
                                    />
                                    {(graduationYearDirty && graduationYearError) && <p className="error-alert">{graduationYearError}</p>}
                                </Form.Group>
                            </div>
                            <Form.Label style={{ marginBottom: '15px' }}> Целевой </Form.Label>
                            <div className="group-select-elements" >
                                <Radio.Group onChange={onTargetStatusChange} value={targetStatus}>
                                    <Radio value={true}>Да</Radio>
                                    <Radio value={false}>Нет</Radio>
                                </Radio.Group>
                            </div>
                            {
                                (targetStatus) &&
                                <Form.Group className="form-group" controlId="formCompanyName">
                                    <Form.Label> Договор с компанией </Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name='companyName'
                                        value={companyName} 
                                        onBlur={blurHandler} 
                                        onChange={companyNameHandler}
                                        isInvalid={!!(companyNameDirty && companyNameError)} 
                                    />
                                    {(companyNameDirty && companyNameError) && <p className="error-alert">{companyNameError}</p>}
                                </Form.Group>
                            }
                            <br />
                            {error && <ErrorMessage message={error} />}
                            <Button type="primary" onClick={handleContinue}> Продолжить </Button>
                            <Button type="text" onClick={() => navigate("/fillProfile3")}> Пропустить </Button>
                        </Form>
                    </div>
                </div>
            </div>
            <Styles>
                <div className="progress"></div>
            </Styles>
        </>
    );
};